const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const fmtMoney = (value) => new Intl.NumberFormat("vi-VN").format(Math.round(Number(value) || 0));

const fmtQty = (value) => {
  const numeric = Number(value || 0);
  if (!Number.isFinite(numeric)) return "0";
  return Number(numeric.toFixed(3)).toString();
};

const splitDate = (value = "") => {
  const [day = "...", month = "...", year = "...."] = String(value).split("/");
  return { day, month, year };
};

export const getPrintTemplate = ({ headerInfo, rows, totals }) => {
  const docDate = splitDate(headerInfo.documentDate);
  const refDate = splitDate(headerInfo.referenceDocumentDate);

  const rowsHtml = rows
    .map(
      (row) => `
      <tr>
        <td class="center">${escapeHtml(row.serialNumber)}</td>
        <td>${escapeHtml(row.itemName)}</td>
        <td class="center">${escapeHtml(row.itemCode)}</td>
        <td class="center">${escapeHtml(row.unit)}</td>
        <td class="right">${fmtQty(row.quantityByDocument)}</td>
        <td class="right">${fmtQty(row.quantityReceived)}</td>
        <td class="right">${fmtMoney(row.unitPrice)}</td>
        <td class="right">${fmtMoney(row.amount)}</td>
      </tr>
    `
    )
    .join("");

  return `
  <html>
    <head>
      <title>Phiếu Nhập Kho</title>
      <style>
        @media print { @page { margin: 10mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 14px; color: #000; padding: 12px; }
        .header { display:flex; justify-content:space-between; margin-bottom: 8px; }
        .title { text-align:center; font-size: 34px; font-weight: 700; text-transform: uppercase; margin: 8px 0 2px; }
        .subtitle { text-align:center; margin-bottom: 8px; }
        table { border-collapse: collapse; width: 100%; margin-top: 8px; }
        th, td { border: 1px solid #000; padding: 3px 5px; vertical-align: middle; }
        th { text-align: center; font-weight: 700; }
        .right { text-align: right; }
        .center { text-align: center; }
        .signatures { margin-top: 34px; display:flex; justify-content:space-between; text-align:center; align-items:flex-start; }
        .sign-box { width: 24%; position: relative; }
        .sign-role { margin-top: 18px; }
        .italic { font-style: italic; }
        .sign-gap { height: 62px; }
        .accountant-date { position: absolute; top: 0; left: 0; width: 100%; text-align: center; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div>
          <div><b>Đơn vị:</b> ${escapeHtml(headerInfo.unit)}</div>
          <div><b>Bộ phận:</b> ${escapeHtml(headerInfo.department)}</div>
        </div>
        <div style="text-align:center;">
          <div><b>Mẫu số: 01 - VT</b></div>
          <div class="italic">(Kèm theo Thông tư số 99/2025/TT-BTC</div>
          <div class="italic">ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      <div class="title">Phiếu nhập kho</div>
      <div class="subtitle">Ngày ${escapeHtml(docDate.day)} tháng ${escapeHtml(docDate.month)} năm ${escapeHtml(docDate.year)}</div>

      <div style="display:flex;justify-content:flex-end;gap:20px;margin-bottom:8px;">
        <div>Số: ${escapeHtml(headerInfo.documentNumber)}</div>
        <div>Nợ: ${escapeHtml(headerInfo.debitCode)}</div>
        <div>Có: ${escapeHtml(headerInfo.creditCode)}</div>
      </div>

      <div>- Họ và tên người giao: ${escapeHtml(headerInfo.delivererName)}</div>
      <div style="margin-top:4px;">
        - Theo ${escapeHtml(headerInfo.referenceDocumentType)} số ${escapeHtml(headerInfo.referenceDocumentNumber)}
        ngày ${escapeHtml(refDate.day)} tháng ${escapeHtml(refDate.month)} năm ${escapeHtml(refDate.year)}
        của ${escapeHtml(headerInfo.referenceDocumentIssuer)}
      </div>
      <div style="margin-top:4px;">Nhập tại kho: ${escapeHtml(headerInfo.warehouseName)} địa điểm ${escapeHtml(headerInfo.warehouseLocation)}</div>

      <table>
        <thead>
          <tr>
            <th rowspan="2">STT</th>
            <th rowspan="2">Tên, nhãn hiệu, quy cách, phẩm chất vật tư, dụng cụ sản phẩm, hàng hóa</th>
            <th rowspan="2">Mã số</th>
            <th rowspan="2">Đơn vị tính</th>
            <th colspan="2">Số lượng</th>
            <th rowspan="2">Đơn giá</th>
            <th rowspan="2">Thành tiền</th>
          </tr>
          <tr>
            <th>Theo chứng từ</th>
            <th>Thực nhập</th>
          </tr>
          <tr>
            <th>A</th>
            <th>B</th>
            <th>C</th>
            <th>D</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
          <tr>
            <td colspan="4" class="center"><b>Cộng</b></td>
            <td class="right"><b>${fmtQty(totals.quantityByDocument)}</b></td>
            <td class="right"><b>${fmtQty(totals.quantityReceived)}</b></td>
            <td class="center"><b>x</b></td>
            <td class="right"><b>${fmtMoney(totals.amount)}</b></td>
          </tr>
        </tbody>
      </table>

      <div style="margin-top:8px;">- Tổng số tiền (viết bằng chữ): ${escapeHtml(headerInfo.totalAmountInWords)}</div>
      <div style="margin-top:4px;">- Số chứng từ gốc kèm theo: ${escapeHtml(headerInfo.attachedOriginalDocuments)}</div>

      <div class="signatures">
        <div class="sign-box">
          <div class="sign-role"><b>Người lập phiếu</b></div>
          <div class="italic">(Ký, họ tên)</div>
          <div class="sign-gap"></div>
        </div>
        <div class="sign-box">
          <div class="sign-role"><b>Người giao hàng</b></div>
          <div class="italic">(Ký, họ tên)</div>
          <div class="sign-gap"></div>
        </div>
        <div class="sign-box">
          <div class="sign-role"><b>Thủ kho</b></div>
          <div class="italic">(Ký, họ tên)</div>
          <div class="sign-gap"></div>
        </div>
        <div class="sign-box">
          <div class="italic accountant-date">Ngày... tháng... năm...</div>
          <div class="sign-role"><b>Kế toán trưởng</b></div>
          <div>(Hoặc bộ phận có nhu cầu nhập)</div>
          <div class="italic">(Ký, họ tên)</div>
        </div>
      </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>`;
};
